import React, { Component } from "react";
import "./Home.css";
import background from "../img/mamca-bg.jpg";
 
export default class Home extends Component {
  render() {
    return (
      <div style={{backgroundImage :"url(" + background + ")"}} className="Home">
          <div className="lander">
            <h1>MAMCA</h1>
            <p>Multi-Actor Multi-Criteria Analysis</p>
          </div>
      </div>
    );
  }
}